import React from "react";
import { LayoutContainer } from "./style";
import { Row, Col, Container } from "react-bootstrap";
import Button from "components/button";
import MainContext from "contexts/main";
import { Link } from "react-router-dom";
const MainLayout = (props) => {
  const { user, logOut } = React.useContext(MainContext);
  return (
    <LayoutContainer>
      <Container>
        <Row>
          <Col sm={12} md={4} lg={3}>
            <aside className="side">
              <div className="info-box">
                <span className="title">کد ملی:</span>
                <span className="value">{user.profile.national_code}</span>
              </div>
              <div className="info-box">
                <span className="title">تلفن همراه:</span>
                <span className="value">{user.profile.phone}</span>
              </div>
              <div className="info-box">
                <Link to="/orders">سفارش‌ها</Link>
              </div>
              <div className="info-box">
                <Link to="/stock">بورس کالا</Link>
              </div>
              <div className="info-box">
                <Link to="/customer-finances">دعوت‌نامه‌ها</Link>
              </div>
              <div className="info-box">
                <Link to="/upload-document">آپلود مدارک</Link>
              </div>
              <div className="info-box">
                <Link to="/change-password">تغییر رمز عبور</Link>
              </div>
              <Button title="خروج" onClick={logOut} />
            </aside>
          </Col>
          <Col sm={12} md={8} lg={9}>
            {props.children}
          </Col>
        </Row>
      </Container>
    </LayoutContainer>
  );
};
export default MainLayout;
